import {PropsWithChildren, useCallback, useEffect} from "react";
import {useAppThunkDispatch} from "../../store/hooks/useAppThunkDispatch";
import {useAppSelector} from "../../store/hooks/useAppSelector";
import {getAuthToken, getAuthUser} from "../../store/auth/auth-store";
import {useGetUserQuery} from "@ots-frontend/ots-data";
import {logout, setAuthCredentialsAndLoadData} from "../../store/auth/actions";
import {useAuth0} from "@auth0/auth0-react";
import Logo from "../../../assets/hubgo_app.svg?react";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";
import {AppBootstrapGateView} from "@ots-frontend/ots-ui";

export const BootstrapGate = (props: PropsWithChildren<unknown>) => {
  const {children} = props;

  const dispatch = useAppThunkDispatch()
  const authToken = useAppSelector(getAuthToken)
  const user = useAppSelector(getAuthUser)

  const {logout: auth0Logout} = useAuth0();

  const shouldBootstrap = !!authToken && !user

  const {data, isLoading, isError, error} = useGetUserQuery(undefined, {
    skip: !shouldBootstrap
  })

  useEffect(() => {
    if (authToken && data && !user) {
      dispatch(setAuthCredentialsAndLoadData({authToken, user: data}))
    }
  }, [authToken, data, user, dispatch]);

  const onRetryButtonClick = useCallback(() => {
    dispatch(logout())

    auth0Logout({
      logoutParams: {returnTo: window.location.origin},
    })

    window.location.reload()
  }, [auth0Logout, dispatch])

  if (shouldBootstrap && isLoading) {
    return (
      <AppBootstrapGateView
        state="loading"
        brandName="HubGo"
      />
    );
  }

  if (shouldBootstrap && isError) {
    const fbqError = error as FetchBaseQueryError | undefined;

    const is404 =
      fbqError &&
      typeof fbqError === "object" &&
      "status" in fbqError &&
      fbqError.status === 404;

    if (is404) {
      return (
        <AppBootstrapGateView
          state="pending"
          brandName="HubGo"
          brandLogo={<Logo/>}
          onRetryClick={onRetryButtonClick}
        />
      );
    }

    return (
      <AppBootstrapGateView
        state="error"
        brandName="HubGo"
        brandLogo={<Logo/>}
        onRetryClick={onRetryButtonClick}
      />
    );
  }

  return (
    <>
      {children}
    </>
  )
}
